import { render } from "./DonutsDashboardDuration.vue?vue&type=template&id=8ff9b208"
import script from "./DonutsDashboardDuration.vue?vue&type=script&lang=js"
export * from "./DonutsDashboardDuration.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__